import React, { forwardRef } from 'react';

import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/system';

interface LabeledNumberProps extends React.HTMLAttributes<HTMLDivElement> {
  number: string;
  label: string;
  width: number;
  numberColor?: string;
  filterTooltipTitle?: string;
  numberAdornment?: React.ReactNode;
}

// eslint-disable-next-line prefer-arrow-callback
export default forwardRef(function LabeledNumber(
  { number, label, width, numberColor, filterTooltipTitle, numberAdornment, ...rest }: LabeledNumberProps,
  ref,
) {
  const theme = useTheme();
  const inner = (
    <Box
      ref={ref}
      sx={{
        color: 'inherit',
        width,
        [theme.breakpoints.down('lg')]: {
          width: 'auto',
          paddingRight: '8px',
        },
      }}
      {...rest}
    >
      <Typography
        sx={{
          fontWeight: 800,
          fontSize: '16px',
          lineHeight: 1.27,
          whiteSpace: 'nowrap',
          display: 'inline-flex',
          alignItems: 'center',
          ...(numberColor ? { color: numberColor } : {}),
        }}
      >
        {number}
        {numberAdornment}
      </Typography>
      <Typography
        sx={{
          fontSize: 10,
          lineHeight: 1.27,
          fontVariant: 'all-small-caps',
          whiteSpace: 'nowrap',
        }}
      >
        {label}
      </Typography>
    </Box>
  );
  if (filterTooltipTitle) {
    return (
      <Tooltip title={filterTooltipTitle}>
        {inner}
      </Tooltip>
    );
  }
  return inner;
});
